<template>
  <modal v-if="isOpen" @hide-modal="hideModal()" :maxWidth="'450px'">
    <template v-slot:content>
      <div class="relative w-full">
          <div class="header">
                <h3 class="text-center">Microdeposit Agreement</h3>
                <div class="micro-wrapper">
                    <h5><span class="text-red-600 text-center">IMPORTANT:</span> Order incomplete until microdeposit verified.</h5>
                </div>
                <p v-if="!showWhy" @click="showWhy = !showWhy" class="cursor-pointer text-2xl text-center mt-1/2 blue-text leading-snug underline">Why must I do this?</p>
                <p v-if="showWhy" class="mt-1 dark-blue-text leading-snug">Per NACHA's ACH regulations, account ownership verification is now required.</p>
                <p class="mt-1/2 dark-blue-text leading-snug">Follow these steps to complete verification:</p>
                <ol class="list-decimal pl-1 leading-snug">
                    <li>Wait 24-48 hours to recieve an email from Stripe with "Verify your bank account for Samsara Inc." in the subject line</li>
                    <li>Click the "Verify deposit" link in the email and follow steps to enter microdeposit verification code</li>
                </ol>
                <div class="good-email-wrapper">
                    <p class="mt-0 dark-blue-text leading-snug">The email will be sent to: <span class="bold">{{ shipping.email }}</span></p>
                </div>
                <p class="mt-1 dark-blue-text leading-snug text-xl">By selecting "Proceed with Microdeposit" you agree to complete the verification process. Order will be incomplete until then.</p>
                <vButton
                    position="center"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="primary text-lg md:text-xl"
                    wrapperStyling="mt-1 !mb-1/2 p-0"
                    height="42px"
                    :disabled="false"
                    @onClickEvent="submitPaymentData"
                >
                    <template v-slot:content>
                        Proceed with Microdeposit
                    </template>
                </vButton>
                <vButton
                    position="center"
                    mobile="12"
                    tablet="12"
                    desktop="12"
                    styling="blue-text underline text-sm md:text-xl"
                    wrapperStyling="!mt-0 !mb-0"
                    height="42px"
                    :disabled="false"
                    @onClickEvent="toReview"
                >
                    <template v-slot:content>
                        Choose another method
                    </template>
                </vButton>
          </div>
      </div>
    </template>
  </modal>
</template>
<style lang="scss" scoped>
  .header {
    padding: 18px 20px;
    height: fit-content;
  }
  .micro-wrapper {
      padding: 10px;
      background-color: #FFCCCB; 
      text-align: center;
      border-radius: 5px;
  }
  hr {
    border: -1px solid #E7EAEE;
    width: 103%;
    position: relative;
    margin-left: -1.5%;
  }
  img {
    max-width: 250px;
    height: fit-content;
  }
  .content-wrapper {
    padding: 44px 0;
    padding-right: 50px;
  }
  .good-email-wrapper {
      margin-top: 10px;
      border: 3px solid #0384FB;
      padding: 10px;
      border-radius: 5px;
      text-align: center;
  }
  @media (max-width: 736px) {
    .header {
      padding: 18px 12px;
    }
    .content-wrapper {
      padding: 20px;
      padding-top: 0;
    }
  }
</style>
<script>
import modal from '../../utils/modal';
import vButton from "../../utils/button";
import { mapGetters } from "vuex";

export default {
  components: {
    modal,
    vButton,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
  },
  data() { 
    return {
        showWhy: false,
    }
  },
  computed: {
    ...mapGetters('shipping', [
        'shipping'
    ]),
  },
  methods: {
    hideModal() {
      this.$emit("hide-modal");
    },

    submitPaymentData() {
        this.$emit("submit-payment-data");
        this.hideModal();
    },

    toReview() {
        this.$emit("route-to-review");
    },
  },
};
</script>
